<template>
  <div class="batterySwapOrderMgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">{{ $t('lang.Swapping Order') }}</p>
      <p v-if="view=='detail'" @click="cancelHandle">{{ $t('lang.Swapping Order') }}</p>
      <p v-if="view=='detail'">>{{ $t('lang.Order Details') }}</p>
      <p v-if="view=='process'" @click="cancelHandle">{{ $t('lang.Swapping Order') }}</p>
      <p v-if="view=='process'">>{{ $t('lang.Swapping Order') }}</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="list">
        <span>{{ $t('lang.Order number') }}：</span>
        <el-input class="list-input" size="mini" v-model="form.orderNo"
                  clearable maxlength="50"
                  @keyup.native="form.orderNo = form.orderNo.replace(/[^\w\.\/]/ig,'')"></el-input>
        <span class="ml10">{{ $t('lang.Card number') }}</span>
        <el-input class="list-input" size="mini" v-model="form.accountNo" maxlength="50" clearable
                  @input="form.accountNo = form.accountNo.replace(/[^\d]/g,'')"
        ></el-input>
        <span class="ml10">{{ $t('lang.Order status') }}：</span>
        <el-select v-model="form.status" size="mini" class="list-input"
                   :placeholder="$t('lang.Please select order Status')" clearable>
          <el-option
            v-for="(item,index) in ORDER_STATUS"
            :key="item.value"
            :label="$t('lang.'+ item.label)"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="ml10">{{ $t('lang.Equipment name') }}：</span>
        <el-input class="list-input" size="mini" v-model="form.deviceName" clearable maxlength="50"></el-input>
      </div>
      <div class="list">
        <span>{{ $t('lang.Equipment number') }}：</span>
        <el-input class="list-input" size="mini" v-model="form.primaryDeviceNo" clearable maxlength="50"></el-input>
        <span class="ml10">{{ $t('lang.time') }}：</span>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          v-model="timeArr"
          type="datetimerange"
          range-separator="-"
          value-format="timestamp"
          :start-placeholder="$t('lang.start time')"
          :end-placeholder="$t('lang.end time')">
        </el-date-picker>
        <span class="ml10">{{ $t('lang.Organization') }}：</span>
        <query-unit-tree @change="handleChange"/>
        <div class="blue-btn ml10" @click="onsearch">{{ $t('lang.Inquire') }}</div>
        <div class="normal-btn ml10" @click="confirmDownloadBtnClick">{{ $t('lang.Export') }}</div>
      </div>
      <el-table
        :data="recordList"
        style="width: 100%"
        class="table-custom"
      >
        <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
        <el-table-column width="200" prop="orderNo" :label="$t('lang.Order number')"></el-table-column>
        <el-table-column width="200" prop="createTime" :label="$t('lang.Order time')">
          <template slot-scope="{row}">
            {{ $changeTime.showTime(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column width="200" prop="endTime" :label="$t('lang.end time')">
          <template slot-scope="{row}">
            {{ $changeTime.showTime(row.endTime) }}
          </template>
        </el-table-column>
        <el-table-column width="200" prop="accountNo" :label="$t('lang.Card number')"></el-table-column>
        <el-table-column width="120" prop="orderStatusCode" :label="$t('lang.Order status')">
          <template slot-scope="{row}">
            {{ $t('lang.' + $changeObj(order_Status_Code)[row.orderStatusCode]) }}
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('lang.Device address')" width="300"></el-table-column>
        <el-table-column width="200" prop="deviceNo" :label="$t('lang.Switch cabinet number')"></el-table-column>
        <el-table-column width="200" prop="deviceName" :label="$t('lang.Name of switch cabinet')"></el-table-column>
        <el-table-column width="200" :label="$t('lang.Swap in and swap out Battery SN')">
          <template slot-scope="{row}">
            <p>{{ row.inBatteryCommunicationBoardNo }}</p>
            <p>{{ row.outBatteryCommunicationBoardNo }}</p>
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('lang.Switch in and switch out of the cabinet door')">
          <template slot-scope="{row}">
            <p>{{ $t('lang.Swap in') }}:{{ row.inChargePortSeqNo }}</p>
            <p>{{ $t('lang.Swap out') }}:{{ row.outChargePortSeqNo }}</p>
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('lang.Swap in and out of power')">
          <template slot-scope="{row}">
            <p>{{ $t('lang.Swap in') }}:{{ row.inBatterySoc }}</p>
            <p>{{ $t('lang.Swap out') }}:{{ row.outBatterySoc }}</p>
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('lang.Swap in and swap out health status')">
          <template slot-scope="{row}">
            <p>{{ $t('lang.Swap in') }}:{{ row.inBatterySoh }}</p>
            <p>{{ $t('lang.Swap out') }}:{{ row.outBatterySoh }}</p>
          </template>
        </el-table-column>
        <el-table-column width="150" prop="originalAmount" :label="$t('lang.lump sum')"></el-table-column>
        <el-table-column :label="$t('lang.Operating')" width="320px" fixed="right">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" @click="onDetailBtnClick(row)">{{ $t('lang.View order details') }}
            </el-button>
            <!-- <div class="text-btn fixed-width-100" @click="onDetailBtnClick(row)">{{$t('lang.View order details')}}</div> -->
            <el-button size="mini" type="primary" @click="onProcessBtnClick(row)">{{ $t('lang.Check progress') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="dfcc">
        <el-pagination
          :current-page="form.beginIndex + 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="main-body" v-if="view == 'detail'">
      <battery-swap-order-mgmt-detail-view :editData="editData"
                                           @cancel="cancelHandle"></battery-swap-order-mgmt-detail-view>
    </div>
    <div class="main-body" v-if="view == 'process'">
      <battery-swap-order-process-view :editData="editData" @cancel="cancelHandle"></battery-swap-order-process-view>
    </div>
  </div>
</template>

<script>
import {thailandOrderManage} from '@/api/orderManagement'
import {BUSINESS_TYPE, ORDER_STATUS, order_Status_Code} from '@/utils/constant'
import Utils from '../../utils/utils.js'
import BatterySwapOrderMgmtDetailView from "./batterySwapOrderMgmtDetailView";
import BatterySwapOrderProcessView from "./batterySwapOrderProcessView";
import queryUnitTree from '@/components/common/queryUnitTree';
import {exportExcel} from "../../api/export";

export default {
  name: 'batterySwapOrderMgmt',
  data() {
    return {
      //是否正在导出的标志
      isExportFlag: false,
      order_Status_Code,
      ORDER_STATUS,
      BUSINESS_TYPE,
      timeArr: [],
      form: {
        type: 1,
        businessType: 0,//列表都是0,开卡是31，续费32
        orderNo: '',
        accountNo: '',
        beginTime: '',
        endTime: '',
        status: '',
        primaryDeviceNo: '',
        deviceName: '',
        beginIndex: 0,
        pageSize: 10,
        exportType: 34
      },
      recordList: [],
      total: 0,
      view: 'list',
      unitNo: [],
      editData: {}
    }
  },
  mounted() {
    this.$set(this.timeArr, 0, this.$m().set({
      'hour': 0,
      'minute': 0,
      'seconds': 0
    }).valueOf())
    this.$set(this.timeArr, 1, this.$m().set({
      'hour': 23,
      'minute': 59,
      'seconds': 59
    }).valueOf())
    if (this.$route.query.recordNo) {
      this.view = 'process';
      this.$nextTick(() => {
        this.editData = {
          recordNo: this.$route.query.recordNo
        };
      });
    }
    this.thailandOrderManage();
  },
  methods: {
    //导出
    confirmDownloadBtnClick() {
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm export'), "", {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.downloadBtnClick();
        })
        .catch(action => {
        });
    },
    //导出
    async downloadBtnClick() {
      if (this.isExportFlag) {
        this.$message.warning(this.$t('lang.Being exported') + '...')
        return
      }
      let self = this;
      let params = {
        ...this.form
      };
      if (this.timeArr && this.timeArr.length > 0) {
        params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
        params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
      } else {
        params.beginTime = null;
        params.endTime = null;
      }
      if (this.unitNo && this.unitNo.length > 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      try {
        this.isExportFlag = true
        await exportExcel(params)
        this.isExportFlag = false
        this.$message.success(this.$t('lang.Export successful'))
        setTimeout(function () {
          self.$router.push('/managePage/downloadTask')
        }, 1000)
      } catch (e) {
        this.isExportFlag = false
      }
    },
    onsearch() {
      this.form.beginIndex = 0;
      this.thailandOrderManage();
    },
    // list
    async thailandOrderManage() {
      try {
        const params = {
          ...this.form
        };
        if (this.timeArr && this.timeArr.length > 0) {
          params.beginTime = this.$changeTime.sendTime(this.timeArr[0], 'x');
          params.endTime = this.$changeTime.sendTime(this.timeArr[1], 'x');
        } else {
          params.beginTime = null;
          params.endTime = null;
        }
        if (this.unitNo && this.unitNo.length > 0) {
          params.unitNo = this.unitNo[this.unitNo.length - 1];
        } else {
          params.unitNo = null;
        }
        const res = await thailandOrderManage(params);
        this.recordList = res.ldata;
        this.total = res.mdata.total;
      } catch (e) {
        console.log(e);
      }
    },
    // select组件
    handleChange(val) {
      this.unitNo = val;
    },
    handleCurrentChange(page) {
      this.form.beginIndex = page - 1;
      this.thailandOrderManage();
    },
    handleSizeChange(pageSize) {
      this.form.pageSize = pageSize;
    },
    // 查看详情
    onDetailBtnClick(row) {
      this.editData = row;
      this.view = 'detail';
    },

    onProcessBtnClick(data) {
      this.editData = data;
      this.view = 'process';
    },
    cancelHandle() {
      this.view = 'list';
    },
  },
  components: {
    queryUnitTree,
    BatterySwapOrderProcessView,
    BatterySwapOrderMgmtDetailView
  }
}
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 165px;
    }

    .list-input {
      width: 180px;
    }
  }

  .table-custom {
    .text-btn {
      // width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 120px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/orderMgmt/rentOrderMgmt.vue